export default __webpack_public_path__ + "static/media/logo.2ec3e8e7.png";